import React, {FC} from "react";
import styled from "styled-components";
import { ProfileBeaconControl } from "./ProfileBeaconComponents";
import { red } from "@material-ui/core/colors";
// import {ProfileBeaconInputField} from './ProfileBeaconComponents';


interface Props {
    id?: string;
    name?: string;
    label?: string;
    value?: string;
    iconUrl?: string;
    pattern?: any;
    errorsMap?: any;
    type?: string;
    iconPosition?: string;
    isSubscriptionEmail?: boolean;
    maxlength?: number;
    minlength?: number;
    placeholder?: string;
    format?: string;
    onInput?: (event: any) => void;
    onChange?:(event: any) => void;
    onKeyDown?:(event:any) =>void;
    onBlur?: (event: any) => void;
    customValidate?: (event: any) => void;
    formatType?: string;
    isPersonalInfo?: boolean;
    isPlanInfoError?: boolean;
    isEmailNotOnFileError?: boolean;
    isPlanInfo?: boolean;
    prefix?:string;
    suffix?:string;
    errorMessage?:string;
    className?:string;
    isSignUpActivationCodeError?:boolean;
   
}

const StyledInputField = styled(ProfileBeaconControl)`
  --beacon-form-icon-space-position-inline-start: left 0px top 50%;   
  --beacon-form-icon-space-position-inline-end: right 0px top 50%; 
  --beacon-form-icon-space-padding: 25px; 
  --beacon-form-field-size-border-width-default: ${({isPlanInfoError, isEmailNotOnFileError, isSignUpActivationCodeError }) => (isPlanInfoError || isEmailNotOnFileError || isSignUpActivationCodeError) && "2px"};
  --beacon-form-field-color-border-default: ${({isPlanInfoError, isEmailNotOnFileError, isSignUpActivationCodeError}) => (isPlanInfoError || isEmailNotOnFileError || isSignUpActivationCodeError) && 'var(--beacon-form-field-color-border-error)'}; 
  --beacon-form-field-color-text-default: ${({isPlanInfoError, isSignUpActivationCodeError}) => (isPlanInfoError || isSignUpActivationCodeError) && 'var(--beacon-form-field-color-text-error)'};
  padding-right: ${({isPersonalInfo}) => isPersonalInfo && "12px"};
  --beacon-form-font-size: 18px;
  --beacon-form-label-font-size: 0;
  display: ${({isPlanInfo}) => isPlanInfo && "flex"};
  width: ${({type, isSubscriptionEmail}) => type === "email" ? isSubscriptionEmail ? "313px" : "240px": "170px"};
  @media(max-width: 1024px){
    width: ${({type, isSubscriptionEmail}) => type === "email" ? isSubscriptionEmail ? "247px" : "225px": "170px"};
  }
  @media(max-width: 640px){
    width: ${({isPlanInfo, isPrefAndSubPage, type, isSubscriptionEmail}) => isPlanInfo ? "140px" : isPrefAndSubPage? "100%" : type === "email" ? isSubscriptionEmail ? "100%" : "225px": "170px"};
  }
  
  span{
    color: #929BA3;
   
  }


 

`;

const Input: FC<Props> = ({
                              id,
                              label,
                              name,
                              isPlanInfo,
                              value,
                              pattern,
                              placeholder,
                              iconUrl,
                              iconPosition,
                              isSubscriptionEmail,
                              isPersonalInfo,
                              isPrefAndSubPage,
                              type,
                              maxlength,
                              minlength,
                              format,
                              formatType,
                              errorsMap,
                              onInput,
                              customValidate,
                              isPlanInfoError,
                              isEmailNotOnFileError,
                              isSignUpActivationCodeError,
                              onBlur,
                              disabled,
                              onChange,
                              onKeyDown,
                              prefix,
                              suffix,
                              errorMessage,
                              className                             

                          }) => {
      
    return (
        <StyledInputField inline >
          <input
          id={id} 
          isPlanInfo={isPlanInfo} 
          disabled={disabled} 
          name={name} 
          type={type} 
          value={value} 
          prefix={prefix}
          suffix={suffix}
          stepper-variant="none"
        iconUrl={iconUrl} 
        icon-position={iconPosition}
          maxlength={maxlength} 
          errorMessage={errorMessage}
          
          
        placeholder={placeholder} 
        pattern={pattern} 
        isSubscriptionEmail={isSubscriptionEmail} aria-label={name}
        label={label}
        minlength={minlength} 
        format={format} 
        formatType={formatType} 
        onBlur={onBlur}
        onInput={onInput} 
        onChange={onChange}
        onKeyDown={onKeyDown}
        errorsMap = {errorsMap} 
        customValidate={customValidate} 
        isPersonalInfo={isPersonalInfo} 
        isPrefAndSubPage={isPrefAndSubPage}
        isPlanInfoError={isPlanInfoError}
        aria-invalid={isPlanInfoError || isEmailNotOnFileError ||  isSignUpActivationCodeError}
        style={{color:(isSignUpActivationCodeError || isEmailNotOnFileError || isPlanInfoError )? 'red':'inherit'}}
       
        
          isEmailNotOnFileError={isEmailNotOnFileError}
          isSignUpActivationCodeError={isSignUpActivationCodeError}/>
          <span slot="prefix" style={{color:isPlanInfoError ? 'red':'#929BA3'}}>{prefix}</span>
          <span slot="suffix" style={{color:isPlanInfoError ? 'red':'#929BA3'}}>{suffix}</span>
          {/* {isPlanInfoError?(<span slot="prefix">{prefix}</span>):(<span slot="prefix">{prefix}</span>)}
          {isPlanInfoError?(<span slot="suffix" >{suffix}</span>):(<span slot="suffix" className="b-color-text--error">{suffix}</span>)} */}
          
         
        </StyledInputField> 
    );
}
export default Input;